// extracted by mini-css-extract-plugin
export default {"MonthsNavigation":"DGzLB","activeMonthBox":"OGmMe","wrap":"cXChu","months":"tEhyd","month":"_34yFJ","year":"CqJmR","skeleton-progress":"_8HPv-"};